// folders structure
var folders = {};
folders.templates = "/templates/";
folders.checkout = folders.templates + "checkout/";
folders.modals = folders.templates + "modals/";
folders.myAccount = folders.templates + "my-account/";
folders.imagesRoot = "/media/products/images/";
folders.forms = folders.templates + "forms/";


var templates = {
  'support.html': require('Templates/support.html'),
  'section-landing.html': require('Templates/section-landing.html'),
  'basic.html': require('Templates/basic.html'),
  'basic-nav.html': require('Templates/basic-nav.html'),
  'basic-nav-form.html': require('Templates/basic-nav-form.html'),
  'basic-form.html': require('Templates/basic-form.html'),
  'support-faq.html': require('Templates/support-faq.html'),
  'two-columns.html': require('Templates/two-columns.html'),
  'repair-single.html': require('Templates/repair-single.html'),
  'warranty-lookup.html': require('Templates/warranty-lookup.html'),
  'training-schedule.html': require('Templates/training-schedule.html'),
  'content-blocks.html': require('Templates/content-blocks.html'),
  'error-code-lookup.html': require('Templates/error-code-lookup.html'),
  checkout: {
    cart_content: folders.checkout + "cart_content.html",
    billing_address: folders.checkout + "billing_address.html",
    shipping_address: folders.checkout + "shipping_address.html",
    shipping_method: folders.checkout + "shipping_method.html",
    additional_info: folders.checkout + "additional_info.html",
    payment_method: folders.checkout + "payment_method.html",
    order_totals: folders.checkout + "order_totals.html"
  },
  myAccount: {
    // "home": folders.myAccount + "my-account-index.html",
    "home": require('Templates/my-account/my-account-index.html'),
    // "orders": folders.myAccount + "orders.html",
    // "address-book": folders.myAccount + "address-book.html",
    // "saved-carts": folders.myAccount + "saved-carts.html",
    // "payments": folders.myAccount + "payments.html",
    // "invoices": folders.myAccount + "invoices.html",
  },
  modals: {
    index: require('../templates/modals/index.pug'),
  }
}

module.exports = {
  api: "api/",
  cart_status_locked: "FREIGHT QUOTE READY",
  folders: folders,
  templates: templates,
  imagesPlaceholder: 'https://www.atmgurus.com/assets/img/img-placeholder-640.png'
}


// WEBPACK FOOTER //
// ./src/app/config.js